module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAgCAYAAABQISshAAAAAXNSR0IArs4c6QAAAVtJREFUWEftl01ywjAMhZ96krDoPTgKWQSy6xl6BYYFDQu4BGs4RzfNSRAT/1CS2MYT2owdrF1mJDufnmzJxEswJmCUQAJTMSkSmCB4GUVqlfnMoUDXR38/Ek2v6evfrGf9D5ciNVWYNdG8xI9tEapAwqfACYQ5CAf6Qu6i4BJzXHBqfHT8I2qxxwp7MBYm3wSis2JThFd4B+PYyd6GKqzvFQHQLi3CWSuqKuF+ifFLS4F8d0A+DCBtF1WaXCLDRZS0l/mVVmGuS1HjOxxMZyRIEJ+UdA97kCCipi1GW5yjUWTI9RumIgP6yGRAfBtiz+9fb60BigQFAlbNqhk9bMbysIvxRFp9i7PeEGJmsjU3GU9On76Q6YXo01xG9HmZ98iIOX1uq6TIc/n7+2iXIp94k5NtDGYGYeR6PI8BQrSxXh+JEKIPEilEGyRiiF+QyCEkSIFFbAfbdAFdAXc6Q3sdaUtbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/hot.png
// module id = i6tK
// module chunks = 1